module.exports = __webpack_public_path__ + "static/media/fold_line_small_off.1e78cba4.svg";